import gql from 'graphql-tag';
import { AccountClient, cache } from '@nile/graphql';

const Auth = {
  isAuthenticated: AccountClient.readQuery({
    query: gql`
      query data {
        isLoggedIn
      }
    `
  }).isLoggedIn,
  authenticate(cb) {},
  validateCache() {
    let cookie = document.cookie;
    let isLoggedIn = !!(
      (
        cookie.match(/uitoken\=([^;]*)/) && // eslint-disable-next-line
        cookie.match(/uitoken\=([^;]*)/).length > 0 && // eslint-disable-next-line
        cookie.match(/uitoken\=([^;]*)/)[1].length > 0 &&
        cookie.match(/app-csrf\=([^;]*)/) &&
        cookie.match(/app-csrf\=([^;]*)/).length > 0 &&
        cookie.match(/app-csrf\=([^;]*)/)[1].length > 0
      ) // eslint-disable-next-line
    );

    cache.writeData({
      data: {
        isLoggedIn: isLoggedIn
      }
    });
    window.location.reload();
  },
  signout() {
    this.validateCache();
  },
  setAuth() {
    cache.writeQuery({
      query: gql`
        query isLoggedIn {
          isLoggedIn
        }
      `,
      data: {
        isLoggedIn: !!(
          (
            document.cookie.match(/uitoken\=([^;]*)/) && // eslint-disable-next-line
            document.cookie.match(/uitoken\=([^;]*)/).length > 0 && // eslint-disable-next-line
            document.cookie.match(/uitoken\=([^;]*)/)[1].length > 0 &&
            document.cookie.match(/app-csrf\=([^;]*)/) &&
            document.cookie.match(/app-csrf\=([^;]*)/).length > 0 &&
            document.cookie.match(/app-csrf\=([^;]*)/)[1].length > 0
          ) // eslint-disable-next-line
        )
      }
    });
    this.isAuthenticated = AccountClient.readQuery({
      query: gql`
        query data {
          isLoggedIn
        }
      `
    }).isLoggedIn;
  }
};

export default Auth;
